/*
 * project-reveal.js — gentle fade-up reveal for the sections that
 * follow the hero on /pages/make-* hub pages.
 *
 * Reuses the [data-reveal] CSS already defined in
 * component-project-kit.css — no per-section markup required.
 *
 * Behaviour:
 *   - Only sections AFTER the hero are tagged.
 *   - Content already in view on load is NOT hidden (no flash).
 *   - Honours prefers-reduced-motion (does nothing; content stays visible).
 *   - Design-mode safe: re-reveals on section load so editing isn't hidden.
 */
(function () {
  if (window.__projectRevealInit) return;
  window.__projectRevealInit = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    var hero = document.querySelector('project-hero[data-hub-page]');
    if (!hero) return;

    var heroSection = hero.closest('.shopify-section') || hero.parentElement;
    if (!heroSection) return;

    // Collect the section wrappers that come after the hero.
    var targets = [];
    var sib = heroSection.nextElementSibling;
    while (sib) {
      if (sib.classList && sib.classList.contains('shopify-section')) targets.push(sib);
      sib = sib.nextElementSibling;
    }
    if (!targets.length || reduced) return;

    var vh = window.innerHeight || document.documentElement.clientHeight;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.04 }
    );

    targets.forEach(function (el, i) {
      // Leave anything already on screen alone — avoids a hide/flash.
      if (el.getBoundingClientRect().top < vh * 0.88) return;
      el.setAttribute('data-reveal', '');
      el.style.setProperty('--reveal-delay', Math.min(i, 3) * 80 + 'ms');
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var t = e.target;
      if (t && t.hasAttribute && t.hasAttribute('data-reveal')) t.classList.add('is-revealed');
    });
  }
})();
